export default class ModuleThreeService {
  
  static getAmountOfModuleThree(moduleOneAndModuleTwoOne, moduleThree){
    
    let amount =  
        this.getFgtsIncidencePreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree) +
        this.getFgtsIncidencePreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree) +
        this.getFgtsPenaltyPreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree) +
        this.getFgtsPenaltyPreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree) +
        this.getPreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree) +
        this.getPreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree) +
        this.getOthers(moduleThree.others, moduleOneAndModuleTwoOne)
    
    return amount;
      
  }
  static getFgtsIncidencePreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree){
    return moduleOneAndModuleTwoOne * moduleThree.fgtsIncidencePreviousNoticeIndemnified / 100
  }
  static getFgtsIncidencePreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree){
    return moduleOneAndModuleTwoOne * moduleThree.fgtsIncidencePreviousNoticeWorked / 100
  }
  static getFgtsPenaltyPreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree){
    return moduleOneAndModuleTwoOne * moduleThree.fgtsPenaltyPreviousNoticeIndemnified / 100
  }
  static getFgtsPenaltyPreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree){
    return moduleOneAndModuleTwoOne * moduleThree.fgtsPenaltyPreviousNoticeWorked / 100
  }
  static getOthers(others, moduleOneAndModuleTwoOne){
    if(!others)
        return 0
    let amount = 0
    for (let i = 0; i < others.length; i++)
        amount += (others[i].percent * moduleOneAndModuleTwoOne) / 100
    
    return amount
  }
  static getPreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree){
    return moduleOneAndModuleTwoOne * moduleThree.previousNoticeIndemnified / 100
  }
  static getPreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree){
    return moduleOneAndModuleTwoOne * moduleThree.previousNoticeWorked / 100
  }
} // class



// WEBPACK FOOTER //
// ./src/service/ModuleThreeService.js